import React, { useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2"; 

const passwordLetterMessage = "Password must contain at least 6 letters";
const countPasswordLetters = (value) => (String(value).match(/[A-Za-z]/g) || []).length;

function ResetPassword() {
  const [password, setPassword] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const email = location.state?.email;

  const resetPassword = async (e) => {
    e.preventDefault();

    if (!email) {
      Swal.fire({
        icon: "warning",
        title: "Session Expired",
        text: "Email not found! Please restart the process.",
        confirmButtonColor: "#f39c12",
      });
      navigate("/forgetpas");
      return;
    }

    if (countPasswordLetters(password) < 6) {
      Swal.fire({
        icon: "warning",
        title: "Weak Password",
        text: passwordLetterMessage,
        confirmButtonColor: "#f39c12",
      });
      return;
    }

    try {
      // ✅ Fixed: Backend 'password' name expect kar raha hai, isliye humne 'password' hi bheja
      await axios.post("https://uniformnx-com.onrender.com/user/reset-password", {
        email: email,
        password: password, 
      });

      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Password Reset Successfully",
        timer: 2000,
        showConfirmButton: false,
      });

      // Thoda wait karke login par bhejenge
      setTimeout(() => navigate("/login"), 2000); 
    } catch (err) {
      console.error("Reset Error:", err);
      Swal.fire({
        icon: "error",
        title: "Failed",
        text: err.response?.data?.message || "Error resetting password",
        confirmButtonColor: "#d33",
      });
    }
  };

  return (
    <div
      style={{
        textAlign: "center",
        padding: "50px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundImage: "url(https://png.pngtree.com/background/20210709/original/pngtree-cartoon-education-training-cram-school-picture-image_917042.jpg)",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="col-11 col-md-5">
        <form
          onSubmit={resetPassword}
          className="form-control p-5 shadow"
          style={{
            background: "rgba(255,255,255,0.2)",
            backdropFilter: "blur(10px)",
            border: "none",
            borderRadius: "15px"
          }}
        >
          <h2 className="text-white mb-4 fw-bold">Reset Password</h2>
          
          <p className="text-white-50 mb-4">
            Resetting password for: <br />
            <strong className="text-white">{email}</strong>
          </p>

          <input
            type="password"
            className="form-control mb-4 text-center mx-auto w-75"
            placeholder="Enter New Password"
            value={password}
            required
            autoFocus
            onChange={(e) => setPassword(e.target.value)}
          />

          <button 
            type="submit" 
            className="btn btn-light w-75 fw-bold py-2 shadow-sm"
            style={{ borderRadius: "10px" }}
          >
            Update Password
          </button>
        </form>
      </div>
    </div>
  );
}

export default ResetPassword;
